import { createStore } from 'vuex'
import getters from './getters'

// 获得全部module
const files = require.context('./modules', false, /\.js$/)
const modules = {}
// 收集
files.keys().forEach((key) => {
  // 文件名为key
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
Object.keys(modules).forEach((key) => {
  // 带命名空间，防止不唯一
  modules[key]['namespaced'] = true
})
const store = createStore({ modules, getters })

/**
 * 安装vuex
 * @param {*} app
 */
export function installStore(app) {
  app.use(store)
}

export default store

